import React from 'react'
import PropTypes from 'prop-types'

const VirtualKit = (props) => {
  const { virtualKit, onSelect } = props

  return (
    <div
      className="hover:bg-blue-100 cursor-pointer flex justify-between py-2"
      onClick={() => onSelect(virtualKit)}
    >
      <p className="text-base">{virtualKit.name}</p>
      {virtualKit && virtualKit.price && <div> ${virtualKit.price}</div>}
    </div>
  )
}

VirtualKit.propTypes = {
  virtualKit: PropTypes.object,

  onSelect: PropTypes.func,
}

VirtualKit.defaultProps = {
  onSelect: () => undefined,
}

export default VirtualKit
